import axios from '@/axios';

const actions = {
  async getUserManagement(obj) {
    try {
      const depots = await axios('transporter/depots');
      const users = await axios('transporter/users');
      const roles = await axios('transporter/roles');
      return {
        depots: depots.data,
        users: users.data,
        roles: roles.data,
      };
    } catch (err) {
      return err;
    }
  },

  async getList(obj) {
    try {
      return axios('transporter/users');
    } catch (err) {
      return err;
    }
  },

  async getVehicleTypes(obj, { orderNo }) {
    try {
      return axios(`transporter/vehicle_types?order_no=${orderNo}`);
    } catch (err) {
      return err;
    }
  },
  async add(obj, data) {
    try {
      return await axios.post('transporter/users', data);
    } catch (err) {
      return err;
    }
  },
};

export default actions;
